import { usePlanningTranslation } from '@libs/utils/translations'
import moment from 'moment'
import type { FC } from 'react'
import React from 'react'

import Corner from '../Corner/Corner'

type Props = {
  date: string
}

const WeekCorner: FC<Props> = ({ date }) => {
  const { t } = usePlanningTranslation()
  const weekIndex = moment(date).startOf('isoWeek').week()

  return (
    <Corner className='z-[2]' position='topLeft' type='dark'>
      {t('weekly.header.weekIndex', { weekIndex })}
    </Corner>
  )
}

export default WeekCorner
